import instance from "../axios_base";

//���oñ�֤����i
export let apiGetReport = (
  PartNumber,
  ProductName,
  SupplierName,
  signState,
  Company
) =>
  instance.post("/PeriodicReview/GetReport", {
    PartNumber,
    ProductName,
    SupplierName,
    signState,
    Company,
  });

export let apiReject = (Reason, ReportGUID, ProcessGUID) =>
  instance.post("/PeriodicReview/Reject", { Reason, ReportGUID, ProcessGUID });

export let apiAgree = (Reason, ReportGUID, ProcessGUID) =>
  instance.post("/PeriodicReview/Agree", { Reason, ReportGUID, ProcessGUID });

//���oñ�־��{
export let apiGetLog = (SourceGUID) =>
  instance.get(`/PeriodicReview/GetLog/?SourceGUID=${SourceGUID}`);
